import styled from 'styled-components';
import { Link } from 'react-router-dom';
import { maxMediaQueries } from '@finect/tabular-utils/mediaQueries';

const Option = styled.div`
  position: relative;
  padding: 18px 0;
  margin: 0 15px;
  color: ${({ theme, selected }) => (selected ? theme.mainColor : theme.colors.font)};

  &:hover {
    color: ${({ theme }) => theme.mainColor};
  }

  ${maxMediaQueries.phablet`
    display: none;
  `};
`;

export const NavOptionLink = Option.withComponent(Link);

export const NavOption = styled(Option)`
  padding-right: 21px;
  cursor: default;

  svg {
    position: absolute;
    top: 24px;
    right: 0;
  }

  ul {
    position: absolute;
    z-index: 1;
    top: 54px;
    left: -5px;
    visibility: hidden;
    opacity: 0;
    padding: 6px 0;
    border-radius: ${({ theme }) => theme.borderRadius};
    box-shadow: ${({ theme }) => theme.boxShadow};
    background: #fff;
    line-height: 30px;
    white-space: nowrap;
    transform: translateY(-6px);
    transition: opacity 0.15s 0s ease, transform 0.15s 0s cubic-bezier(0.49, 0.42, 0.52, 0.98), visibility 0s 0.15s ease;
  }

  &:hover {
    ul {
      visibility: visible;
      opacity: 1;
      transform: translateY(0);
      transition: opacity 0.15s 0s ease, transform 0.15s 0s cubic-bezier(0.49, 0.42, 0.52, 0.98), visibility 0s 0s ease;
    }
  }

  ${maxMediaQueries.miniDesktop`
    span {
      display: none;
    }
  `};
`;
